import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { fetchLeads } from 'bundles/project/actions/index';

import { Alert } from 'components/ui/alert';

import EmailModal from 'bundles/project/components/email_modal';
import Leads from 'bundles/project/components/leads/leads';
import LeadsList from 'bundles/project/components/leads/list';
import LeadModal from 'bundles/project/components/leads/modal';
import { defaultFilterValue } from 'bundles/project/components/project_navigator';
import buildLeadsQueryParams from 'bundles/project/components/leads/build_leads_query_params';
import { LAST_UPDATED } from 'bundles/leads/index/table/cell';

import './styles.scss';

export function ProjectLeads({
  availableDatabaseOptions,
  caDownloadPath,
  callLists,
  canDisplayEmailLink,
  commercialEdgeLogoPath,
  currentUser,
  defaultTaskAssignee,
  fetchLeads,
  leadReferralSources,
  leadsPath,
  leadStatuses,
  leaseSpace,
  project
}) {
  const [filters, setFilters] = useState(defaultFilterValue);
  const scopedFilters = leaseSpace ? { ...filters, listingFilter: [leaseSpace.listingId] } : filters;

  useEffect(() => {
    fetchLeads(project.id, buildLeadsQueryParams({ filters: scopedFilters }));
  }, []);

  const [leadsList, setLeadsList] = useState({
    page: 1,
    sortBy: { field: LAST_UPDATED, reverse: true },
  });

  const changeSort = (fieldClicked) => {
    setLeadsList((prevState) => {
      const prevSortBy = prevState.sortBy;
      const reverse = prevSortBy.field === fieldClicked ? !prevSortBy.reverse : false;

      return { ...prevState, sortBy: { field: fieldClicked, reverse } };
    });
  };

  const handleFilterChange = (filter) => {
    setFilters(prevState => ({ ...prevState, ...filter }));
  };

  const setPage = (page) => {
    setLeadsList(prevState => ({ ...prevState, page }));
  };

  return (
    <div className="deal-project-leads-tab">
      <Leads
        tasksEnabled={false}
      >
        {leaseSpace && (
          <Alert className="mb-4" icon={faInfoCircle} severity="info">
            Showing {leaseSpace.leadCount} of {leaseSpace.projectLeadCount} — filtered to this space.
            The full library lives on the building.
          </Alert>
        )}

        <LeadsList
          availableDatabaseOptions={availableDatabaseOptions}
          caDownloadPath={caDownloadPath}
          callLists={callLists}
          callListsEnabled={currentUser && currentUser.callListsEnabled}
          canDisplayEmailLink={canDisplayEmailLink}
          changeSort={changeSort}
          commercialEdgeLogoPath={commercialEdgeLogoPath}
          databaseMembers={[...project.collaborators, ...project.otherAuthorizedUsers]}
          defaultTaskAssignee={defaultTaskAssignee}
          filters={scopedFilters}
          fromDealTab
          handleFilterChange={handleFilterChange}
          hasTasksEnabled={false}
          leadReferralSources={leadReferralSources}
          leadsPath={leadsPath}
          leadStatuses={leadStatuses}
          leaseSpace={leaseSpace}
          page={leadsList.page}
          setPage={setPage}
          sort={leadsList.sortBy}
          onStartImport={() => {}}
        />
      </Leads>

      <LeadModal leadReferralSources={leadReferralSources} leadStatuses={leadStatuses}/>
      <EmailModal projectTasksActivities={false}/>
    </div>
  );
}

ProjectLeads.propTypes = {
  availableDatabaseOptions: PropTypes.array,
  caDownloadPath: PropTypes.string,
  callLists: PropTypes.array,
  canDisplayEmailLink: PropTypes.bool,
  commercialEdgeLogoPath: PropTypes.string,
  currentUser: PropTypes.object,
  defaultTaskAssignee: PropTypes.object,
  fetchLeads: PropTypes.func,
  leadReferralSources: PropTypes.array,
  leadsPath: PropTypes.string,
  leadStatuses: PropTypes.array,
  leaseSpace: PropTypes.shape({
    leadCount: PropTypes.number.isRequired,
    listingId: PropTypes.number.isRequired,
    projectLeadCount: PropTypes.number.isRequired
  }),
  project: PropTypes.object,
};

const mapDispatchToProps = {
  fetchLeads
};

export default connect(null, mapDispatchToProps)(ProjectLeads);